import React, { createContext, useContext, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'

const PdfExportContext = createContext(null)

export const PdfExportProvider = ({ children }) => {
  const readyCallbacksRef = useRef({})

  const registerComponent = useCallback(componentId => {
    return new Promise(resolve => {
      readyCallbacksRef.current[componentId] = resolve
    })
  }, [])

  const signalComponentReady = useCallback(componentId => {
    const callback = readyCallbacksRef.current[componentId]
    if (callback) {
      callback()
      delete readyCallbacksRef.current[componentId]
    }
  }, [])

  const waitForComponents = useCallback(
    componentIds => {
      const promises = componentIds.map(id => registerComponent(id))
      return Promise.all(promises)
    },
    [registerComponent]
  )

  const cleanup = useCallback(() => {
    readyCallbacksRef.current = {}
  }, [])

  return (
    <PdfExportContext.Provider value={{ signalComponentReady, waitForComponents, cleanup }}>
      {children}
    </PdfExportContext.Provider>
  )
}

PdfExportProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export const usePdfExport = () => {
  const context = useContext(PdfExportContext)
  if (!context) {
    throw new Error('usePdfExport must be used within PdfExportProvider')
  }
  return context
}
